// File for logic corresponding to print component
import { Component } from 'js-component-framework';

/**
 * Component for print
 */
export default class Print extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.initPrintToggle();
  }

  /**
   * Initialize print toggle
   */
  initPrintToggle() {
    const {
      printToggle,
    } = this.children;

    // Do nothing if there is no toggle.
    if (!printToggle) {
      return;
    }

    printToggle.addEventListener('click', (event) => {
      event.preventDefault();
      window.print();
    });
  }
}
